import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chart-header',
  templateUrl: './chart-header.component.html',
  styleUrl: './chart-header.component.scss',
})
export class ChartHeaderComponent {
  @Input() title: string = 'Chart Title';
  @Input() infoText: string = 'Chart Info Text';
  @Input() isDemo: boolean = false;
}
